import { gql, TypedDocumentNode } from "@apollo/client";

export type UpdateActivityTypeParticipationMutationResponse = {
  updateActivityTypeParticipation: {
    success: boolean;
    message: string;
    participation?: {
      id: string;
      title: string;
      quantity?: number | null;
      isTypeLevelParticipation: boolean;
    } | null;
  };
};

export type UpdateActivityTypeParticipationMutationVariables = {
  id: string;
  startDate: string;
  endDate?: string;
  quantity: number;
  title: string;
  description?: string | null;
};

export const UPDATE_ACTIVITY_TYPE_PARTICIPATION_MUTATION: TypedDocumentNode<
  UpdateActivityTypeParticipationMutationResponse,
  UpdateActivityTypeParticipationMutationVariables
> = gql`
  mutation UpdateActivityTypeParticipation(
    $id: ID!
    $startDate: ISO8601DateTime!
    $endDate: ISO8601DateTime
    $quantity: Float!
    $title: String!
    $description: String
  ) {
    updateActivityTypeParticipation(
      id: $id
      startDate: $startDate
      endDate: $endDate
      quantity: $quantity
      title: $title
      description: $description
    ) {
      success
      message
      participation {
        id
        title
        quantity
        isTypeLevelParticipation
      }
    }
  }
`;

export type DeleteActivityTypeParticipationMutationResponse = {
  deleteActivityTypeParticipation: {
    success: boolean;
    message: string;
  };
};

export type DeleteActivityTypeParticipationMutationVariables = {
  id: string;
};

export const DELETE_ACTIVITY_TYPE_PARTICIPATION_MUTATION: TypedDocumentNode<
  DeleteActivityTypeParticipationMutationResponse,
  DeleteActivityTypeParticipationMutationVariables
> = gql`
  mutation DeleteActivityTypeParticipation($id: ID!) {
    deleteActivityTypeParticipation(id: $id) {
      success
      message
    }
  }
`;
